import React, { Component } from 'react';
import Connecting from './Connecting.js';
// import logo from './logo.svg';
import './App.css';

var ReactRouter = require('react-router-dom');
var Router = ReactRouter.BrowserRouter
var Route = ReactRouter.Route

//
import ReactGA from 'react-ga'
ReactGA.initialize('UA-76600448-1')

function logPageView() {
  ReactGA.pageview(window.location.hash);
}

class App extends Component {

  render() {
    return (
      <Router>
        <Route exact path='/' component={Connecting} onUpdate={logPageView} />
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js